import React, { PropsWithChildren, useState } from "react";
import { Outlet } from "react-router";
import { TopBar } from "./components/MenuBar/TopBar";
import { BottomBar } from "./components/MenuBar/BottomBar";
import "./layout.css";
import UserProfileDialog from "./components/UserProfile/UserProfilePage";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useUser } from "./components/UserContext";
import ClientLicenseHealthBanner from "./components/LicenseManagement/ClientLicenseHealthBanner";
import { CollectionAISidebar } from './features/ai/CollectionAISidebar';

export const AppLayout: React.FC<PropsWithChildren> = ({ children }) => {
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const handleProfileOpen = () => setIsProfileOpen(true);
    const handleProfileClose = () => setIsProfileOpen(false);
    const { activeClient } = useUser();
    const showBanner = !!activeClient?.licenseAccess;
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

    return (
        <div className="app-root">
            <TopBar handleProfileOpen={handleProfileOpen} handleProfileClose={handleProfileClose} />
            {showBanner && (
                <ClientLicenseHealthBanner activeClient={activeClient} />
            )}
            <Box
                className={`page-shell ${showBanner ? "with-license-banner" : ""}`}
                sx={{ display: 'flex', flexDirection: 'row', overflow: 'hidden' }}
            >
                {/* Main content — always rendered */}
                <Box sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    minWidth: 0,
                }}>
                    <main className="app-main">
                        {children}
                    </main>

                    {/* Mobile collapsed bar — only visible below lg */}
                    {!isDesktop && (
                        <CollectionAISidebar />
                    )}
                </Box>

                {/* Desktop permanent sidebar — only visible at lg and above */}
                {/* Hide AI Bar for now, we can enable it later when we have more features to show in the sidebar
                  {isDesktop && (
                     <CollectionAISidebar />
                    
                )}
                 */}
            </Box>

            <BottomBar />
            <UserProfileDialog
                open={isProfileOpen}
                onClose={handleProfileClose}
            />
        </div>
    );
};